import { VALUE_STRIP } from "../config/brand";
import { FadeUp } from "../components/Reveal";

export const ValueStrip = () => (
  <section
    aria-label="Bundle at a glance"
    data-testid="value-strip"
    className="border-y border-mauve/30 bg-warmwhite"
  >
    <div className="mx-auto grid max-w-[1280px] grid-cols-2 gap-y-6 px-5 py-8 sm:grid-cols-3 sm:px-8 lg:grid-cols-5">
      {VALUE_STRIP.map((v, i) => (
        <FadeUp key={v.label} delay={i * 0.06} className="text-center">
          <p className="font-serif text-3xl font-medium tracking-tight text-plum" data-testid={`value-strip-${i}`}>
            {v.value}
          </p>
          <p className="mt-1 text-[11px] font-bold uppercase tracking-[0.18em] text-plumcharcoal/55">
            {v.label}
          </p>
        </FadeUp>
      ))}
    </div>
  </section>
);
